import classes from './loader.module.scss';
const Loader = () => {
  return (
    <div className={classes.loader}>
      <span></span>
      <span></span>
      <span></span>
    </div>
  );
};

export default Loader;
